import gql from "graphql-tag";

export const GET_USER_EXPORT_PERMISSION = gql`
  query getUserExportPermission {
    getUserExportPermission
  }
`